export const yAxisTicksTitleGap = 24;

export const yAxisDiagramGap = 20;
export const xAxisDiagramGap = 7;

export const barLineWidth = 16;
export const barLineGap = 4;
export const graphSizes = [0, 0, 80, 105, 130, 200, 200, 200, 200, 280];
